import { manageErrorLogs } from "../../helpers/commonFunction";
import {
  clearTables,
  checkTablesInDB,
  safeTransaction,
} from "../../helpers/db";

export const insertUserDataInDB = async (data) => {
  try {
    const tables = ["userData", "lastAPICallTime", "systemLogs"];
    checkTablesInDB(tables);
    await safeTransaction(tables, async (tx) => {
      const userDataTable = tx.table(tables[0]);
      const lastAPICallTimeTable = tx.table(tables[1]);
      await clearTables(tx, tables);

      const isExist = await userDataTable
        .where("id")
        .equals(data?.id)
        .toArray();
      if (isExist?.length > 0) {
        await userDataTable.update(isExist[0]?.id, data);
      } else {
        await userDataTable.add(data);
      }
      await lastAPICallTimeTable.add({
        call: 0,
        time: new Date(),
      });
    });
  } catch (error) {
    manageErrorLogs(error);
    return null;
  }
};

export const updateUserTableDataInDB = async (data) => {
  try {
    const tables = ["userData"];
    checkTablesInDB(tables);
    await safeTransaction(tables, async (tx) => {
      const userDataTable = tx.table(tables[0]);
      await userDataTable.update(data?.id, data);
    });
  } catch (error) {
    manageErrorLogs(error);
    return null;
  }
};

export const updateNewUserSessionInDB = async (token, refreshToken) => {
  try {
    const tables = ["userData"];
    checkTablesInDB(tables);
    await safeTransaction(tables, async (tx) => {
      const userDataTable = tx.table(tables[0]);
      const userData = await userDataTable.toArray();

      if (userData?.length > 0 && userData[0]?.id) {
        const reqObj = {
          ...userData[0],
          token: token,
          refresh_token: refreshToken,
        };
        await userDataTable.update(reqObj?.id, reqObj);
        localStorage.setItem("user", JSON.stringify(reqObj));
      }
    });
  } catch (error) {
    manageErrorLogs(error);
    return null;
  }
};
